"use strict";
/*
 * Created on 8. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author Radek Beran
 */


var PriceChangeIndexConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PriceChangeIndexConverter, _DataObjectConverter_);

  function PriceChangeIndexConverter() {
    _classCallCheck(this, PriceChangeIndexConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PriceChangeIndexConverter).apply(this, arguments));
  }

  return PriceChangeIndexConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PriceChangeIndexConverter = PriceChangeIndexConverter;